import { ProductPageTemplate } from "@/components/products/ProductPageTemplate";
import {
  Zap, Search, Database, Code, Layers, Globe,
  ShoppingCart, CalendarCheck, Plug, UserCheck,
} from "lucide-react";
import iconValid from "@/assets/icon-valid.jpg";
import type { FeatureGroup, UseCase, Benefit, Step, EnrichmentAttribute } from "@/components/products/types";
import { ValidDemo } from "@/components/products/ValidDemo";

const featureGroups: FeatureGroup[] = [
  {
    titleKey: "productPages.valid.featureGroups.api",
    illustrationKey: "valid-api",
    features: [
      {
        titleKey: "productPages.valid.features.items.validation.title",
        descriptionKey: "productPages.valid.features.items.validation.description",
        icon: Zap,
      },
      {
        titleKey: "productPages.valid.features.items.autocomplete.title",
        descriptionKey: "productPages.valid.features.items.autocomplete.description",
        icon: Search,
      },
      {
        titleKey: "productPages.valid.features.items.enrichment.title",
        descriptionKey: "productPages.valid.features.items.enrichment.description",
        icon: Database,
      },
    ],
  },
  {
    titleKey: "productPages.valid.featureGroups.web",
    illustrationKey: "valid-web",
    features: [
      {
        titleKey: "productPages.valid.features.items.search.title",
        descriptionKey: "productPages.valid.features.items.search.description",
        icon: Globe,
      },
      {
        titleKey: "productPages.valid.features.items.coverage.title",
        descriptionKey: "productPages.valid.features.items.coverage.description",
        icon: Code,
      },
    ],
  },
];

const useCases: UseCase[] = [
  {
    titleKey: "productPages.valid.useCases.items.checkout.title",
    descriptionKey: "productPages.valid.useCases.items.checkout.description",
    icon: ShoppingCart,
  },
  {
    titleKey: "productPages.valid.useCases.items.booking.title",
    descriptionKey: "productPages.valid.useCases.items.booking.description",
    icon: CalendarCheck,
  },
  {
    titleKey: "productPages.valid.useCases.items.systemIntegration.title",
    descriptionKey: "productPages.valid.useCases.items.systemIntegration.description",
    icon: Plug,
  },
  {
    titleKey: "productPages.valid.useCases.items.crmQuality.title",
    descriptionKey: "productPages.valid.useCases.items.crmQuality.description",
    icon: UserCheck,
  },
];

const enrichmentAttributes: EnrichmentAttribute[] = [
  { nameKey: "productPages.valid.enrichmentData.items.county.name", descriptionKey: "productPages.valid.enrichmentData.items.county.description" },
  { nameKey: "productPages.valid.enrichmentData.items.municipality.name", descriptionKey: "productPages.valid.enrichmentData.items.municipality.description" },
  { nameKey: "productPages.valid.enrichmentData.items.district.name", descriptionKey: "productPages.valid.enrichmentData.items.district.description" },
  { nameKey: "productPages.valid.enrichmentData.items.parish.name", descriptionKey: "productPages.valid.enrichmentData.items.parish.description" },
  { nameKey: "productPages.valid.enrichmentData.items.lkfCode.name", descriptionKey: "productPages.valid.enrichmentData.items.lkfCode.description" },
  { nameKey: "productPages.valid.enrichmentData.items.municipalityCode.name", descriptionKey: "productPages.valid.enrichmentData.items.municipalityCode.description" },
  { nameKey: "productPages.valid.enrichmentData.items.property.name", descriptionKey: "productPages.valid.enrichmentData.items.property.description" },
  { nameKey: "productPages.valid.enrichmentData.items.coordinates.name", descriptionKey: "productPages.valid.enrichmentData.items.coordinates.description" },
  { nameKey: "productPages.valid.enrichmentData.items.deso.name", descriptionKey: "productPages.valid.enrichmentData.items.deso.description" },
  { nameKey: "productPages.valid.enrichmentData.items.regso.name", descriptionKey: "productPages.valid.enrichmentData.items.regso.description" },
  { nameKey: "productPages.valid.enrichmentData.items.uuid.name", descriptionKey: "productPages.valid.enrichmentData.items.uuid.description" },
  { nameKey: "productPages.valid.enrichmentData.items.postalCode.name", descriptionKey: "productPages.valid.enrichmentData.items.postalCode.description" },
  { nameKey: "productPages.valid.enrichmentData.items.city.name", descriptionKey: "productPages.valid.enrichmentData.items.city.description" },
];

const benefits: Benefit[] = [
  {
    titleKey: "productPages.valid.benefits.items.returns.title",
    descriptionKey: "productPages.valid.benefits.items.returns.description",
  },
  {
    titleKey: "productPages.valid.benefits.items.experience.title",
    descriptionKey: "productPages.valid.benefits.items.experience.description",
  },
  {
    titleKey: "productPages.valid.benefits.items.costs.title",
    descriptionKey: "productPages.valid.benefits.items.costs.description",
  },
];

const steps: Step[] = [
  {
    titleKey: "productPages.valid.howItWorks.steps.first.title",
    descriptionKey: "productPages.valid.howItWorks.steps.first.description",
  },
  {
    titleKey: "productPages.valid.howItWorks.steps.second.title",
    descriptionKey: "productPages.valid.howItWorks.steps.second.description",
  },
  {
    titleKey: "productPages.valid.howItWorks.steps.third.title",
    descriptionKey: "productPages.valid.howItWorks.steps.third.description",
  },
];

const ValidPage = () => {
  return (
    <ProductPageTemplate
      productKey="valid"
      icon={iconValid}
      featureGroups={featureGroups}
      useCases={useCases}
      enrichmentAttributes={enrichmentAttributes}
      benefits={benefits}
      steps={steps}
      accentClass="bg-coral/10"
      demoPlaceholder={<ValidDemo />}
    />
  );
};

export default ValidPage;
